import { useLocation, useParams } from "react-router-dom";
import { useGetAssignmentQuery } from "../../assignments/assignmentsSlice";

const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

const useBreadcrumbs = () => {
  const location = useLocation();
  const { dialogId, taskId } = useParams();
  const { data: assignment } = useGetAssignmentQuery(
    { assignmentId: taskId },
    { skip: taskId == null }
  );

  let crumbs = location?.pathname
    ?.split("/")
    ?.filter((item) => item !== "")
    ?.map((crumb, idx) => ({
      itemKey: crumb,
      id: crumb,
      caption: capitalize(crumb),
      to: `/${location?.pathname
        ?.split("/")
        .slice(1, idx + 2)
        .join("/")}`,
    }));

  // Remove the last crumb if it matches dialogId
  if (crumbs.length > 0 && crumbs[crumbs.length - 1].id === dialogId) {
    crumbs = crumbs.slice(0, -1);
  }
  // Remove the last crumb if it matches taskId
  if (crumbs.length > 0 && crumbs[crumbs.length - 1].id === taskId) {
    crumbs = crumbs.slice(0, -1);
    if (assignment?.topic) {
      crumbs.push({
        itemKey: taskId,
        id: taskId,
        caption: assignment?.topic,
        to: "#",
      });
    }
  }

  // Prepend "home"
  const homeCrumb = {
    itemKey: "home",
    id: "home",
    caption: "Home",
    to: "/",
  };

  return [homeCrumb, ...(crumbs || [])];
};

export default useBreadcrumbs;
